module.exports = __webpack_public_path__ + "officialStatic/img/solution-gongdi.7baa5fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-gongdi.png
// module id = jREi
// module chunks = 0